import { getThirdwebBaseUrl } from "../../utils/domains.js";
import { getClientFetch } from "../../utils/fetch.js";
import { stringify } from "../../utils/json.js";
/**
 * @internal
 */
export async function track({ client, ecosystem, data, }) {
    const fetch = getClientFetch(client, ecosystem);
    const event = {
        source: "sdk",
        ...data,
    };
    return fetch(`${getThirdwebBaseUrl("analytics")}/event`, {
        method: "POST",
        body: stringify(event),
    }).catch(() => { });
}
//# sourceMappingURL=index.js.map